import Chip from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router-dom';
import { globalStyles as styles } from '../../core/style/gstheme';
import GS from '../../grafsync/grafsync';

class ExternalTypeLink extends React.Component {

    handleDeleteLink() {
        // We do this directly to ensure direction of link delete is correct 
        GS.deleteProperty(this.props.source, this.props.graph, this.props.property, this.props.id);
    }

    render() {

        const { id, isReadOnly, classes, highlight, label } = this.props;

        return (
            <Chip
                color="primary"
                style={highlight ?
                    { backgroundColor: '#FF6F00' }
                    :
                    {}
                }
                data-test={highlight ? "highlighted-external-type-link": "external-type-link"}
                className={classes.chip}
                onDelete={!isReadOnly ? (() => this.handleDeleteLink()) : null}
                label={label || id} />
        );
    }
}

ExternalTypeLink.defaultProps = {
    property: "type",
    highlight: false
};

ExternalTypeLink.propTypes = {
    id: PropTypes.string.isRequired,
    highlight: PropTypes.bool,
    graph: PropTypes.string.isRequired,
    property: PropTypes.string,
    label: PropTypes.string,
    source: PropTypes.string,
    isReadOnly: PropTypes.bool,
    classes: PropTypes.object
};

export default withRouter(withStyles(styles)(ExternalTypeLink));